// utils/parseHtmlTextToJson.ts

export function parseHtmlTextToJson<T = any>(htmlText?: string): T[] {
  if (!htmlText || typeof htmlText !== "string") return [];

  try {
    // 1. Remove HTML tags
    let text: string = htmlText
      .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
      .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    if (!text) return [];

    text = text.replace(/\s+/g, " ");

    // 2. Wrap thành array nếu chưa có
    if (!text.startsWith("[")) {
      text = `[${text}]`;
    }

    // 3. Chuẩn hóa JS-object → JSON
    const jsonText: string = text
      // quote keys
      .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":')
      // remove trailing commas
      .replace(/,\s*}/g, "}")
      .replace(/,\s*]/g, "]");

    // 4. Parse JSON
    const parsed: unknown = JSON.parse(jsonText);

    return Array.isArray(parsed) ? (parsed as T[]) : [];
  } catch (error) {
    return [];
  }
}
